import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// 1. CORE PAGES
import Homepage from './Homepage/Homepage';
import Careers from './Careers/Careers';
import Blogs from './Blogs/Blogs';
import ContactUs from './ContactUs/Contactus';
import Aboutpromicon from './AboutUs/Aboutpromicon';

// 2. ALLIANCE PAGES (Mapped from your Alliances folder)
import AmazonAlliance from './Alliances/Amazon Alliance';
import FlipkartAlliance from './Alliances/Flipkart Alliance';
import MeeshoAlliance from './Alliances/Meesho Alliance';
import MetaAlliance from './Alliances/Meta Alliance';
import MicrosoftAlliance from './Alliances/Microsoft Alliance';
import SapAlliance from './Alliances/SAP Alliance';

// 3. SERVICE CATEGORY EXAMPLES (Pick the main ones for your grid)
import AmazonAccountMgmt from './Ecommerce Management/AmazonAccountManagement';

import EcommerceMarketplaceManagement from './Homepage Services/Ecommercemarketplacemanagement';
import ProductListingandCatalogStrategy from './Homepage Services/Productlistingandcatalogstrategy';
import AmazonPPCandFlipkartAdsManagement from './Homepage Services/Amazonppcflipkartadsmanagement';
import AplusContent from './Homepage Services/Apluscontentinfographicsstorefront';
import EnterpriseSystemsProcesses from './Homepage Services/Enterprisesystemprocess';
import ProductivityDataandAutomationtools from './Homepage Services/Productivitydataandautomationtools';
import BrandRegistryAccountSetup from './Ecommerce Management/BrandRegistryAccountSetup';


import AmazonAccountManagement from './Ecommerce Management/AmazonAccountManagement';
import FlipkartAccountManagement from './Ecommerce Management/FlipkartAccountManagement';
import MeeshoAccountManagement  from './Ecommerce Management/MeeshoAccountManagement';
import AmazonProductListing  from './Listing and Cataloging/AmazonProductListing';
import FlipkartProductListing  from './Listing and Cataloging/FlipkartProductListing';
import MeeshoProductListing  from './Listing and Cataloging/MeeshoProductListing';
import ShopsyProductListing  from './Listing and Cataloging/ShopsyProductListing';
import CatalogOptimization  from './Listing and Cataloging/CatalogOptimization';
import ListingSEOContentEnhancement  from './Listing and Cataloging/ListingSEOContentEnhancement';
import AmazonPPCManagement from './Ecommerce Advertising/AmazonPPCManagement';
import FlipkartadsManagement from './Ecommerce Advertising/FlipkartAdsManagement';
import MetaadsOptimization from './Ecommerce Advertising/MetaadsOptimization';

import AmazonAPlusContent from './Branding and Content/AmazonAPlusContent';
import FlipkartRPD from './Branding and Content/FlipkartRPD';
import Infographics from './Branding and Content/Infographics';
import AmazonStoreFront from './Branding and Content/AmazonStoreFront';
import AmazonBrandStory from './Branding and Content/AmazonBrandStory';

import FinancialSystemManagement from './Enterprise Solutions/FinancialSystemsManagement';
import EnterpriseSystemImplementation from './Enterprise Solutions/EnterpriseSystemImplementation';
import BusinessProcessOptimization from './Enterprise Solutions/BusinessProcessOptimization';
import EnterpriseIntegrationAutomation from './Enterprise Solutions/EnterpriseIntegrationAutomation';

import BusinessProductivitySolutions from './Productivity and Intelligence/BusinessProductivitySolutions';
import BusinessApplicationsCRM from './Productivity and Intelligence/BusinessApplicationsCRM';
import DataReportingAutomation from './Productivity and Intelligence/DataReportingAutomation';
import CloudInfrastructureSupport from './Productivity and Intelligence/CloudInfrastructureSupport';


import AMAccountManagement from './Partners/Amazon/AMAccountManagement';
import AMAccountRegistrationandLaunch from './Partners/Amazon/AMAccountRegistrationandLaunch';
import AMAccountReinstatement from './Partners/Amazon/AMAccountReinstatement';
import AMAdvertising from './Partners/Amazon/AMAdvertising';
import AMListingandCataloging from './Partners/Amazon/AMListingandCataloging';
import Storefront from './Partners/Amazon/Storefront';
import AplusContentInfographic from './Partners/Amazon/AplusContentInfographics';

import FKAccountcreationandlaunch from './Partners/Flipkart/FKAccountcreationandlaunch';
import FKAccountManagement from './Partners/Flipkart/FKAccountManagement';
import FKAdvertising from './Partners/Flipkart/FKAdvertising';
import Flipkart2RPD from './Partners/Flipkart/Flipkart2RPD';

import MSAccountCreationandlaunch from './Partners/Meesho/MSAccountCreationandlaunch'
import MSAccountManagement from './Partners/Meesho/MSAccountManagement'
import MSAdvertising from './Partners/Meesho/MSAdvertising'

import Advertising from './Partners/Meta/Advertising'
import AudienceTargetingStrategy from './Partners/Meta/AudienceTargetingStrategy'
import CreativeAdOptimization from './Partners/Meta/CreativeAdOptimization'
import TrackingPerformanceAnalytics from './Partners/Meta/TrackingPerformanceAnalytics'

import DynamicsBusinessSolutions from './Partners/Microsoft/DynamicsBusinessSolutions'
import Microsoft365 from './Partners/Microsoft/Microsoft365'
import MicrosoftCloudPlatform from './Partners/Microsoft/MicrosoftCloudPlatform'
import MicrosoftSupportServices from './Partners/Microsoft/MicrosoftSupportServices'

import RisewithSAP from './Partners/SAP/RisewithSAP'
import SAPBTP from './Partners/SAP/SAPBTP'
import SAPFICO from './Partners/SAP/SAPFICO'
import SAPS4HANA from './Partners/SAP/SAPS4HANA'
import SAPSupport from './Partners/SAP/SAPSupport'

import PrivacyPolicy from './Policies/PrivacyPolicy'
import RefundCancellationPolicy from './Policies/RefundCancellationPolicy'
import TermsandConditions from './Policies/TermsandConditions'



function App() {
  return (
    <Router>
      <div className="promicon-app">
        <Routes>
          {/* MAIN NAVIGATION */}
          <Route path="/" element={<Homepage />} />
          <Route path="/about-us" element={<Aboutpromicon />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/contact-us" element={<ContactUs />} />

          {/* ALLIANCE ROUTES (Matches the 'to' paths we fixed earlier) */}
          <Route path="/partners/amazon-alliance" element={<AmazonAlliance />} />
          <Route path="/partners/flipkart-alliance" element={<FlipkartAlliance />} />
          <Route path="/partners/meesho-alliance" element={<MeeshoAlliance />} />
          <Route path="/partners/meta-alliance" element={<MetaAlliance />} />
          <Route path="/partners/microsoft-alliance" element={<MicrosoftAlliance />} />
          <Route path="/partners/sap-alliance" element={<SapAlliance />} />

          {/* SERVICE ROUTES (Examples - link these to your service grid cards) */}
          <Route path="/services/amazon-management" element={<AmazonAccountMgmt />} />
          
          
          <Route path="/HomepageServices/Ecommerce-Management" element={<EcommerceMarketplaceManagement />} />
          <Route path="/HomepageServices/Listing-Catalog Strategy" element={<ProductListingandCatalogStrategy />} />
          <Route path="/HomepageServices/Ads-Management" element={<AmazonPPCandFlipkartAdsManagement />} />
          <Route path="/HomepageServices/Aplus-Infographics" element={<AplusContent />} />
          <Route path="/HomepageServices/Enterprise-Systems" element={<EnterpriseSystemsProcesses />} />
          <Route path="/HomepageServices/Productivity-tools" element={<ProductivityDataandAutomationtools />} />

          <Route path="/EnterpriseSolutions/Amazonaccountmanagement" element={<AmazonAccountManagement />} />
          <Route path="/EnterpriseSolutions/Flipkartaccountmanagement" element={<FlipkartAccountManagement />} />
          <Route path="/EnterpriseSolutions/Meeshoaccountmanagement" element={<MeeshoAccountManagement />} />
          <Route path="/EnterpriseSolutions/Brand-Registry" element={<BrandRegistryAccountSetup />} />
          
          <Route path="/ListingandCataloging/Amazon-Listing" element={<AmazonProductListing />} />
          <Route path="/ListingandCataloging/Flipkart-Listing" element={<FlipkartProductListing />} />
          <Route path="/ListingandCataloging/Meesho-Listing" element={<MeeshoProductListing />} />
          <Route path="/ListingandCataloging/Shopsy-Listing" element={<ShopsyProductListing />} />
          <Route path="/ListingandCataloging/Catalog-Optimization" element={<CatalogOptimization />} />
          <Route path="/ListingandCataloging/ListingSEO-ContentEnhancement" element={<ListingSEOContentEnhancement />} />
          
          <Route path="/EcommerceAdvertsing/Amazon-advertising" element={<AmazonPPCManagement />} />
          <Route path="/EcommerceAdvertsing/Flipkart-advertising" element={<FlipkartadsManagement />} />
          <Route path="/EcommerceAdvertsing/Meta-advertising" element={<MetaadsOptimization />} />
          
          <Route path="/BrandingandContent/Aplus-Content" element={<AmazonAPlusContent />} />
          <Route path="/BrandingandContent/Flipkart-RPD" element={<FlipkartRPD />} />
          <Route path="/BrandingandContent/Store-front" element={<AmazonStoreFront />} />
          <Route path="/BrandingandContent/AmazonBrand-Story" element={<AmazonBrandStory />} />
          <Route path="/BrandingandContent/Infographics" element={<Infographics />} />

          
          <Route path="/EnterpriseSolutions/Financial-Systems" element={<FinancialSystemManagement />} />
          <Route path="/EnterpriseSolutions/Enterprise-Implementation" element={<EnterpriseSystemImplementation />} />
          <Route path="/EnterpriseSolutions/Businessprocess-Optimization" element={<BusinessProcessOptimization />} />
          <Route path="/EnterpriseSolutions/Enterprise-Integration" element={<EnterpriseIntegrationAutomation />} />

          <Route path="/ProductivityandIntelligence/Productivity-Solutions" element={<BusinessProductivitySolutions />} />
          <Route path="/ProductivityandIntelligence/Applications-CRM" element={<BusinessApplicationsCRM />} />
          <Route path="/ProductivityandIntelligence/Reporting-Automation" element={<DataReportingAutomation />} />
          <Route path="/ProductivityandIntelligence/Cloud-Support" element={<CloudInfrastructureSupport />} />

          <Route path="/Parterns/Amazon/AmazonRegistration-Launch" element={<AMAccountRegistrationandLaunch />} />
          <Route path="/Parterns/Amazon/Amazon-management" element={<AMAccountManagement />} />
          <Route path="/Parterns/Amazon/AmazonRegistration-Launch" element={<AMAccountRegistrationandLaunch />} />
          <Route path="/Parterns/Amazon/Amazonlisting-cataloging" element={<AMListingandCataloging />} />
          <Route path="/Parterns/Amazon/Amazon-Campaignmanager" element={<AMAdvertising />} />
          <Route path="/Parterns/Amazon/Amazon-Reinstatement" element={<AMAccountReinstatement />} />
          <Route path="/Parterns/Amazon/AmazonRegistration-Launch" element={<AMAccountRegistrationandLaunch />} />
          <Route path="/Parterns/Amazon/Aplus-info" element={<AplusContentInfographic />} />
          <Route path="/Parterns/Amazon/Storefront" element={<Storefront />} />

          <Route path="/Parterns/Flipkart/FlipkartAccount-Creation" element={<FKAccountcreationandlaunch />} />
          <Route path="/Parterns/Flipkart/FlipkartAccount-Management" element={<FKAccountManagement />} />
          <Route path="/Parterns/Flipkart/FlipkartAccount-Advertising" element={<FKAdvertising />} />
          <Route path="/Parterns/Flipkart/FlipkartAccount-RPD" element={<Flipkart2RPD />} />

          <Route path="/Parterns/Meesho/MSAccountCreationlaunch" element={<MSAccountCreationandlaunch />} />
          <Route path="/Parterns/Meesho/MSAccount-Management" element={<MSAccountManagement />} />
          <Route path="/Parterns/Meesho/MS-Advertising" element={<MSAccountCreationandlaunch />} />

          <Route path="/Parterns/Meta/Meta-advertising" element={<Advertising />} />
          <Route path="/Parterns/Meta/Audience-Targeting-Strategy" element={<AudienceTargetingStrategy />} />
          <Route path="/Parterns/Meta/CreativeAd-Optimization" element={<CreativeAdOptimization />} />
          <Route path="/Parterns/Meta/Tracking-Performance-Analytics" element={<TrackingPerformanceAnalytics />} />

          <Route path="/Parterns/Microsoft/Dynamic-Solutions" element={<DynamicsBusinessSolutions />} />
          <Route path="/Parterns/Microsoft/Microsoft-365" element={<Microsoft365 />} />
          <Route path="/Parterns/Microsoft/Microsoft-Cloud-Platform" element={<MicrosoftCloudPlatform />} />
          <Route path="/Parterns/Microsoft/Microsoft-SupportServices" element={<MicrosoftSupportServices />} />

          <Route path="/Parterns/SAP/Rise-with-SAP" element={<RisewithSAP />} />
          <Route path="/Parterns/SAP/SAP-BTP" element={<SAPBTP />} />
          <Route path="/Parterns/SAP/SAP-FICO" element={<SAPFICO />} />
          <Route path="/Parterns/SAP/SAP-S4HANA" element={<SAPS4HANA />} />
          <Route path="/Parterns/SAP/SAP-Support" element={<SAPSupport />} />

          <Route path="/Policies/Privacy-Policy" element={<PrivacyPolicy />} />
          <Route path="/Policies/Refund-Cancellation" element={<RefundCancellationPolicy />} />
          <Route path="/Policies/Terms-Conditions" element={<TermsandConditions />} />


          

          






          


          {/* FALLBACK */}
          <Route path="*" element={<Homepage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;